import { render, staticRenderFns } from "./EnvironmentTag.vue?vue&type=template&id=49bae9f8"
import script from "./EnvironmentTag.vue?vue&type=script&lang=js"
export * from "./EnvironmentTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports